import { useEffect, useState } from "react";
import DetailPageLayout from "../Layout/DetailPageLayout";
import {
  NextButton,
  NextButtonText,
  Header,
  ContentContainer,
  RegisterWrapper,
  GenderWrapper,
  DatePicker,
  YearSelect,
  DaySelect,
  MonthSelect,
  CheckLabel,
  Checkbox,
  Option,
  RegisterNameInput,
  CheckLabelWrapper,
} from "./RegisterUserInfo.styles";
import { YEARS, MONTHS, DAYS, useRegister } from "./RegisterUserInfo.helpers";
import { useRecoilState } from "recoil";
import { registerAtom } from "../../recoil/atoms";
import { useReloadWarning } from "../../common/hooks";
import { TextXL } from "../../common/text";

const RegisterUserInfo = () => {
  const [registerAtomValue, setRegisterAtom] = useRecoilState(registerAtom);
  const [isValidateInfo, setIsValidateInfo] = useState(false);
  const [gender, setGender] = useState("");
  const [year, setYear] = useState(YEARS[0]);
  const [month, setMonth] = useState(MONTHS[0]);
  const [day, setDay] = useState(DAYS[0]);
  const [name, setName] = useState("");

  const { mutate: register } = useRegister();

  const onClickRegister = () => {
    if (isValidateInfo) {
      register(registerAtomValue);
    }
  };

  const onChangeYear = (e) => {
    setYear(e.target.value);
  };
  const onChangeMonth = (e) => {
    setMonth(e.target.value);
  };
  const onChangeDay = (e) => {
    setDay(e.target.value);
  };
  const onSelectGender = (e) => {
    setGender(e.target.value);
  };
  const onNameChange = (e) => {
    const currentName = e.target.value;
    setName(currentName);
  };

  useEffect(() => {
    const birth = year.toString() + month.toString() + day.toString();
    if (gender !== "" && name !== "") {
      setIsValidateInfo(true);
      setRegisterAtom((prev) => ({
        ...prev,
        gender: gender,
        birth,
        name,
      }));
    } else {
      setIsValidateInfo(false);
    }
  }, [year, month, day, gender, name]);

  useReloadWarning();

  return (
    <DetailPageLayout headerText={"개인정보"}>
      <ContentContainer>
        <RegisterWrapper>
          <Header>
            <TextXL>개인정보를 입력해주세요</TextXL>
          </Header>
          <GenderWrapper value={gender} onChange={onSelectGender}>
            <CheckLabelWrapper>
              <CheckLabel>
                <Checkbox type="radio" name="gender" value="male" />
                남자
              </CheckLabel>
              <CheckLabel>
                <Checkbox type="radio" name="gender" value="female" />
                여자
              </CheckLabel>
            </CheckLabelWrapper>
          </GenderWrapper>
          <DatePicker>
            <YearSelect name="year" value={year} onChange={onChangeYear}>
              {YEARS.map((y) => {
                return (
                  <Option key={y} value={y}>
                    {y} 년
                  </Option>
                );
              })}
            </YearSelect>
            <MonthSelect name="month" value={month} onChange={onChangeMonth}>
              {MONTHS.map((m) => {
                return (
                  <Option key={m} value={m}>
                    {m} 월
                  </Option>
                );
              })}
            </MonthSelect>
            <DaySelect name="day" value={day} onChange={onChangeDay}>
              {DAYS.map((d) => {
                return (
                  <Option key={d} value={d}>
                    {d} 일
                  </Option>
                );
              })}
            </DaySelect>
          </DatePicker>

          <RegisterNameInput
            onChange={onNameChange}
            value={name}
            placeholder={"이름을 입력해주세요"}
            variant="standard"
          ></RegisterNameInput>
        </RegisterWrapper>

        <NextButton
          onClick={onClickRegister}
          color={isValidateInfo ? "#f44b59" : "#eaeaea"}
        >
          <NextButtonText isValidateInfo={isValidateInfo}>
            회원가입
          </NextButtonText>
        </NextButton>
      </ContentContainer>
    </DetailPageLayout>
  );
};

export default RegisterUserInfo;
